import { useEffect } from "react";
import { useAuth } from "@clerk/react";
import { setTokenProvider } from "../services/tokenStore";

const TEMPLATE = process.env.REACT_APP_CLERK_TEMPLATE_ID || "TLK";

async function fetchClerkToken(getToken) {
  try {
    return await getToken({ template: TEMPLATE });
  } catch {
    return getToken();
  }
}

const ClerkTokenBridge = ({ children }) => {
  const { getToken } = useAuth();

  // Register before children effects so UserGuard's /admin/me probe has a token.
  setTokenProvider(() => fetchClerkToken(getToken));

  useEffect(() => {
    setTokenProvider(() => fetchClerkToken(getToken));
    return () => setTokenProvider(async () => null);
  }, [getToken]);

  return children;
};

export default ClerkTokenBridge;
